import React from 'react';
import { useUser } from '@clerk/clerk-react';
import SignInPrompt from '../../../components/SignInPrompt';
import NoAccessNotice from '../../../components/NoAccessNotice';
import { canUseChangeControl } from '../changes/changeControl';

export default function InvestigationGuard({ children }) {
  const { user, isLoaded, isSignedIn } = useUser();
  if (!isLoaded) return <p role="status">Loading access…</p>;
  if (!isSignedIn) return <SignInPrompt pageName="Sample investigations" />;
  if (!canUseChangeControl(user)) return <NoAccessNotice pageName="Sample investigations" />;
  return children;
}
